import { _ as ve } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.assign-7e79fd7b.js";
import "./web.set-timeout-72b6430f.js";
import { QUERIES as _e, zIndices as ge } from "@ucl/shared-component-foundations";
import { c as D } from "./index-8b07dec9.js";
import E, { forwardRef as he, useRef as K, useState as $, useEffect as k, useCallback as O, useImperativeHandle as be } from "react";
import { createPortal as ye } from "react-dom";
import "./es.object.keys-9d66766f.js";
import { usePopoverIndex as Ce } from "./usePopoverIndex.js";
import { getAriaProps as ue } from "./aria.js";
import "./es.array.concat-d1c9b847.js";
import "./es.array.is-array-7a29277f.js";
import "./es.object.to-string-f55666a8.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as Oe } from "./getMetrics-953aa4f8.js";
import { useEventListener as Pe } from "./useEventListener.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { useWindowSize as we } from "./useWindowSize.js";
import { Button as Be } from "./button.js";
import { Divider as Ne } from "./divider.js";
import { FocusTrap as Se } from "./focusTrap.js";
import { a as Ie } from "./index-5d0f31c6.js";
import { CloseButton as De } from "./closeButton.js";
import { g as Ee } from "./getElementPosition-8d0dbc61.js";
import d, { css as T } from "styled-components";
import { jsxs as P, Fragment as xe, jsx as c } from "react/jsx-runtime";
var le = /* @__PURE__ */ d.div.withConfig({
  displayName: "popupTipstyles__PopupTip",
  componentId: "rpsz2g-0"
})(["&.PopupTip{", ";}"], function(e) {
  var t = e.theme.components.popupTip;
  return T(t.PopupTip);
}), He = /* @__PURE__ */ d.div.withConfig({
  displayName: "popupTipstyles__MobileFixedOverlay",
  componentId: "rpsz2g-1"
})(["&.PopupTip__overlay{", ";}"], function(e) {
  var t, v = e.theme.components.popupTip, w = e.$zIndex;
  return T(v.MobileFixedOverlay, (t = {}, t["@media " + _e.mobile] = {
    zIndex: w
  }, t));
}), ze = /* @__PURE__ */ d.div.withConfig({
  displayName: "popupTipstyles__ContentWrapper",
  componentId: "rpsz2g-2"
})(["&.PopupTip__content-wrapper{", ";}"], function(e) {
  var t = e.theme.components.popupTip;
  return T(t.ContentWrapper);
}), Re = /* @__PURE__ */ d.div.withConfig({
  displayName: "popupTipstyles__Content",
  componentId: "rpsz2g-3"
})(["&.PopupTip__content{", ";}"], function(e) {
  var t = e.theme.components.popupTip;
  return T(t.Content);
}), Ae = /* @__PURE__ */ d.div.withConfig({
  displayName: "popupTipstyles__Header",
  componentId: "rpsz2g-4"
})(["&.PopupTip__header{", ";}"], function(e) {
  var t = e.theme.components.popupTip;
  return T(t.Header);
}), ke = /* @__PURE__ */ d.div.withConfig({
  displayName: "popupTipstyles__TitleWrapper",
  componentId: "rpsz2g-5"
})(["&.PopupTip__title_wrapper{", ";}"], function(e) {
  var t = e.theme.components.popupTip;
  return T(t.TitleWrapper);
}), Fe = /* @__PURE__ */ d.div.withConfig({
  displayName: "popupTipstyles__Title",
  componentId: "rpsz2g-6"
})(["&.PopupTip__title{", ";}"], function(e) {
  var t = e.theme.components.popupTip;
  return T(t.Title);
}), Le = /* @__PURE__ */ d.div.withConfig({
  displayName: "popupTipstyles__Subtitle",
  componentId: "rpsz2g-7"
})(["&.PopupTip__subtitle{", ";}"], function(e) {
  var t = e.theme.components.popupTip;
  return T(t.Subtitle);
}), We = /* @__PURE__ */ d.div.withConfig({
  displayName: "popupTipstyles__Body",
  componentId: "rpsz2g-8"
})(["&.PopupTip__body{", ";}"], function(e) {
  var t = e.theme.components.popupTip;
  return T(t.Body);
}), Me = /* @__PURE__ */ d.div.withConfig({
  displayName: "popupTipstyles__Footer",
  componentId: "rpsz2g-9"
})(["&.PopupTip__footer{", ";}"], function(e) {
  var t = e.theme.components.popupTip;
  return T(t.Footer);
}), Ke = /* @__PURE__ */ d.span.withConfig({
  displayName: "popupTipstyles__Pointer",
  componentId: "rpsz2g-10"
})(["&.PopupTip__pointer{", ";}"], function(e) {
  var t = e.theme.components.popupTip;
  return T(t.Pointer);
}), a = /* @__PURE__ */ function(e) {
  return e.AUTO = "auto", e.TOP = "top", e.BOTTOM = "bottom", e.LEFT = "left", e.RIGHT = "right", e.TOP_START = "top-start", e.TOP_END = "top-end", e.BOTTOM_START = "bottom-start", e.BOTTOM_END = "bottom-end", e.RIGHT_START = "right-start", e.RIGHT_END = "right-end", e.LEFT_START = "left-start", e.LEFT_END = "left-end", e;
}({}), $e = ["open", "children", "placement", "popupTipHeader", "popupTipHeaderSubtitle", "popupTipBody", "className", "isDisabled", "CTAButtonHandler", "CTAButtonLabel", "showButton", "accessibilityOptions", "hideTitleDivider", "exceedOverflow", "neverCloseOnClickOutside", "disableBodyScroll", "timeout", "isPlacementFixed", "onChange"], je = function(t, v, w, x) {
  var u = t.getBoundingClientRect(), m = v.clientHeight + 1, H = v.clientWidth + 1, f = u.top < m, l = u.left < H, n = u.right + H > w - 1, _ = u.bottom + m > x - 1, z = f && n, F = f && l, L = _ && l, R = _ && n;
  if (!(!f && !n && !l && !_))
    return !f && !n && !l ? a.TOP : L && !f && !n ? a.TOP_END : R && !f && !l ? a.TOP_START : !_ && !n && !l ? a.BOTTOM : F && !_ && !n ? a.BOTTOM_END : z && !_ && !l ? a.BOTTOM_START : n && !l ? a.LEFT : !n && l ? a.RIGHT : a.TOP;
}, se = /* @__PURE__ */ he(function(e, t) {
  var v = e.open, w = e.children, x = e.placement, u = x === void 0 ? a.AUTO : x, m = e.popupTipHeader, H = e.popupTipHeaderSubtitle, f = e.popupTipBody, l = e.className, n = e.isDisabled, _ = e.CTAButtonHandler, z = e.CTAButtonLabel, F = z === void 0 ? "Button" : z, L = e.showButton, R = e.accessibilityOptions, j = R === void 0 ? {
    closeButton: {
      ariaLabel: "Close Button"
    }
  } : R, ce = e.hideTitleDivider, g = e.exceedOverflow, de = e.neverCloseOnClickOutside, Te = e.disableBodyScroll, W = e.timeout, U = e.isPlacementFixed, b = e.onChange, i = ve(e, $e), G = Oe({
    label: "PopupTip"
  }), h = K(null), B = K(null), N = K(), V = $({}), me = V[0], q = V[1], Q = we(), J = Q.width, X = Q.height, Y = $(v), r = Y[0], S = Y[1];
  k(function() {
    return S(v);
  }, [v]);
  var Z = Ce(r, se.zIndex), ee = $(u === a.AUTO ? a.TOP : u), s = ee[0], te = ee[1], oe = E.Children.map(w, function(o) {
    return /* @__PURE__ */ E.isValidElement(o) && o.type && o.type === Ie ? /* @__PURE__ */ E.cloneElement(o, {
      role: "button",
      "aria-label": i["aria-label"] || "popup tip"
    }) : /* @__PURE__ */ E.isValidElement(o) ? /* @__PURE__ */ E.cloneElement(o, {
      "aria-label": i["aria-label"] || "popup tip"
    }) : o;
  });
  k(function() {
    te(u === a.AUTO ? a.TOP : u);
  }, [u]);
  var fe = ue("button", j.CTAButton || {}), pe = O(function() {
    if (!(!h.current || !B.current || g)) {
      var o = je(h.current, B.current, J, X);
      o && o !== s && te(o);
    }
  }, [g, s, X, J]);
  k(function() {
    if (r)
      return !U && u === "auto" && pe(), !N.current && W && (N.current = setTimeout(function() {
        return S(!1);
      }, W)), function() {
        N.current && (clearTimeout(N.current), N.current = void 0);
      };
  }, [r, U, u, pe, W]);
  var ie = O(function() {
    n || (S(!0), b == null || b(!0));
  }, [n]), I = O(function() {
    S(!1), b == null || b(!1);
  }, []), y = O(function() {
    n || S(function(o) {
      var p = o ?? !1;
      return b == null || b(!p), !o;
    });
  }, [n]), ne = O(function(o) {
    var p = o.code === "Enter", A = o.code === "Space" || o.code === "Space";
    !p && !A || (o.preventDefault(), y());
  }, [y]), M = O(function() {
    if (!r || !g)
      return q({});
    var o = Ee(h, B, s, "popuptip");
    q(o);
  }, [g, r, s]);
  k(function() {
    return M();
  }, [M]), Pe("scroll", M, void 0, !0), be(t, function() {
    return {
      open: ie,
      close: I,
      toggle: y,
      triggerElement: h.current,
      contentElement: B.current
    };
  }, [I, ie, y]);
  var re = function() {
    var p;
    return /* @__PURE__ */ c(He, {
      $zIndex: Z,
      className: "PopupTip__overlay",
      children: /* @__PURE__ */ c(Se, {
        open: r,
        disableEnforceFocus: !0,
        disableScrollFocusInView: !0,
        onClickedOutside: function(C) {
          var ae;
          r && !((ae = h.current) != null && ae.contains(C.target)) && !de && I();
        },
        onClick: function(C) {
          return C.stopPropagation();
        },
        onKeyDown: function(C) {
          C.stopPropagation(), r && C.code === "Escape" && I();
        },
        children: /* @__PURE__ */ P(ze, {
          ref: B,
          role: "dialog",
          "aria-modal": "true",
          "aria-hidden": !r,
          "aria-label": m,
          className: D(["PopupTip__content-wrapper", "PopupTip__content-wrapper--" + s, (p = {
            "PopupTip__content-wrapper--open": r
          }, p["PopupTip__content-wrapper--" + s + "-open"] = r, p["PopupTip__content-wrapper--overflown"] = g, p["PopupTip__content-wrapper--overflown-" + s] = g, p)]),
          style: Object.assign({}, me, {
            zIndex: Z
          }),
          children: [/* @__PURE__ */ P(Re, {
            className: "PopupTip__content",
            tabIndex: m ? void 0 : 0,
            children: [!!m && /* @__PURE__ */ P(Ae, {
              className: "PopupTip__header",
              children: [/* @__PURE__ */ P(ke, {
                className: "PopupTip__title_wrapper",
                children: [/* @__PURE__ */ c(Fe, {
                  className: "PopupTip__title",
                  children: m
                }), /* @__PURE__ */ c(Le, {
                  className: "PopupTip__subtitle",
                  children: H
                })]
              }), /* @__PURE__ */ c(De, Object.assign({
                "aria-label": "Close Button"
              }, ue("button", j.closeButton), {
                className: "PopupTip__close-btn",
                onClick: I,
                size: "xsmall",
                type: "button"
              }))]
            }), !ce && !!m && /* @__PURE__ */ c(Ne, {
              className: "PopupTip__Divider"
            }), /* @__PURE__ */ c(We, {
              className: D("PopupTip__body", Te && "PopupTip__body--disable-scroll"),
              children: f
            }), L && /* @__PURE__ */ c(Me, {
              className: "PopupTip__footer",
              children: /* @__PURE__ */ c(Be, Object.assign({}, fe, {
                className: "PopupTip__footer-CTA-btn",
                size: "small",
                variant: "primary",
                fullWidth: !0,
                onClick: _,
                children: F
              }))
            })]
          }), /* @__PURE__ */ c(Ke, {
            className: D(["PopupTip__pointer", "PopupTip__pointer--" + s.split("-")[0], "PopupTip__pointer--" + s])
          })]
        })
      })
    });
  };
  return g ? /* @__PURE__ */ P(xe, {
    children: [/* @__PURE__ */ c(le, Object.assign({}, G, i, {
      className: D(["PopupTip", "PopupTip--exceedOverflow", "PopupTip--" + s, l]),
      ref: h,
      onClick: function(p) {
        y(), i == null || i.onClick == null || i.onClick(p);
      },
      onKeyDown: function(p) {
        ne(p), i == null || i.onKeyDown == null || i.onKeyDown(p);
      },
      children: oe
    })), r && (!!m || !!f) && /* @__PURE__ */ ye(re(), document.body)]
  }) : /* @__PURE__ */ P(le, Object.assign({}, G, i, {
    className: D(["PopupTip", {
      "PopupTip--open": r
    }, "PopupTip--" + s, l]),
    ref: h,
    onClick: function(p) {
      y(), i == null || i.onClick == null || i.onClick(p);
    },
    onKeyDown: function(p) {
      ne(p), i == null || i.onKeyDown == null || i.onKeyDown(p);
    },
    children: [oe, (!!m || !!f) && r && re()]
  }));
});
se.zIndex = ge.popover;
export {
  se as P,
  a,
  je as g
};
